import { FC } from 'react';
import { createPortal } from 'react-dom';
import { useSelect } from './hooks';
import { SelectProps } from './select.types';
import { SelectContext } from './context';
import { SelectTrigger, SelectDropdown } from './components';
import { Wrapper } from './select.styled';

type SelectComponentProps = SelectProps & {
  requiredPlaceholderMark?: boolean;
};

export const Select: FC<SelectComponentProps> = (props) => {
  const selectModel = useSelect(props);
  const { state, actions } = selectModel;

  return (
    <SelectContext.Provider value={selectModel}>
      <Wrapper $contained={props.contained} onKeyDown={actions.handleKeyDown}>
        <SelectTrigger />

        {state.isOpen &&
          !state.loading &&
          createPortal(
            <SelectDropdown />,
            props.portalContainer ?? document.body
          )}
      </Wrapper>
    </SelectContext.Provider>
  );
};
